export const API_URL =
  "https://api-smartcity.quecko.org";
